import { Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { ShellComponent } from './shell.component';
import { internalGuard } from './features/conversion/internal.guard';
import { catalogAdminGuard } from './features/products/catalog-admin.guard';

// '' must render, never redirect: the guards' refusal UrlTree is [''], so a redirect would loop.
export const appRoutes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
        title: 'Canvas Builder — Management',
      },
      {
        path: 'products',
        canMatch: [catalogAdminGuard],
        loadChildren: () =>
          import('./features/products/products.routes').then(
            (m) => m.PRODUCTS_ROUTES,
          ),
      },
      {
        path: 'conversions',
        canMatch: [internalGuard],
        loadChildren: () =>
          import('./features/conversion/conversion.routes').then(
            (m) => m.CONVERSION_ROUTES,
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
